export interface BasketQuickBetErrorProps {
  error: EBasketQuickBetError
}

export enum EBasketQuickBetError {
  minBetError = 'minBetError',
  insufficientBalance = 'insufficientBalance'
}
